// ==>using upper case here cuz this is a constant will never change
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'e78dc6c0-e6f7-4f23-8ba7-8f8629b85b4f';
export const MODAL_CLOSE_SEC = 2.5;
